// תרגום תפקידי משתמשים
export const roleTranslations: Record<string, string> = {
  'admin': 'מנהל',
  'service': 'שירות',
  'technician': 'טכנאי',
  'warehouse': 'מחסן',
  'viewer': 'צופה',
  'field_agent': 'איש שטח',
  'external_viewer': 'צופה חיצוני',
  'former_employee': 'עזב את החברה',
};

export const getRoleLabel = (role: string): string => {
  return roleTranslations[role] || role;
};
